import UserRequestsView from './views/user-requests/user-requests.view.vue';
import UserDetailsView from './views/user-details/user-details.view.vue'

export const USER_REQUESTS_ROUTES = {
  USER_REQUESTS: {
    NAME: 'private.user-requests',
    PATH: ''
  },
  USER_REQUEST_DETAILS: {
    NAME: 'private.user-requests.details',
    PATH: ':id'
  }
};

export const userRequestsRoutes = [
  { 
    name: USER_REQUESTS_ROUTES.USER_REQUESTS.NAME,
    path: USER_REQUESTS_ROUTES.USER_REQUESTS.PATH,
    component: UserRequestsView
  },
  { 
    name: USER_REQUESTS_ROUTES.USER_REQUEST_DETAILS.NAME,
    path: USER_REQUESTS_ROUTES.USER_REQUEST_DETAILS.PATH,
    component: UserDetailsView
  },
  {
    path: '/', redirect: { name: USER_REQUESTS_ROUTES.USER_REQUESTS.NAME }
  }
];